var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('editor-content',{staticClass:"editor__content bg-white p-2 border border-dark",attrs:{"editor":_vm.editor}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }